import React from "react"
import * as Components from "../../components/components"
import { EventBus } from "../../eventbus"
import { NoState } from "../../models/interfaces"
import { UrlAnlage } from "../../models/urlanlage"

interface UrlAnlageViewProps {
    index: number
    anlage: UrlAnlage
}

export class UrlAnlageView extends React.Component<UrlAnlageViewProps, NoState> {
    constructor(props: UrlAnlageViewProps) {
        super(props)
    }
    onChange(property: string, value: string) {
        EventBus.instance.emit("changeProperty", `anlagen.${this.props.index}.${property}`, value)
    }
    render() {
        return (
            <Components.Row>
                <Components.Col size={12}>
                    <Components.FormGroup label="URL (BT-124)" inline={true} labelClassName="small">
                        <Components.TextEdit value={this.props.anlage.url} onChange={this.onChange.bind(this, "url")} />
                    </Components.FormGroup>
                </Components.Col>
            </Components.Row>
        )
    }
}
